<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line" *ngIf="!showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-normal" (click)="updateShowSearch()">
        <i class="material-icons">search</i>
      </div>
    </div>
    <div class="ir-line-content">
      <span
        >Action Plan <strong>({{ actionPlans?.length }})</strong></span
      >
    </div>
  </div>
  <div class="ir-line th-header-search" *ngIf="showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-unactive">
        <i class="material-icons">search</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="ir-line-content">
      <input
        autoFocus
        type="search"
        name="Search"
        placeholder="{{ 'common.placeholders.search' | translate }}"
        [(ngModel)]="query"
        focus="showSearch"
      />
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="th-loading" *ngIf="loading">
    <span>{{ 'common.loading' | translate }}...</span>
  </div>
  <action-plan-list-table
    [actionPlans]="actionPlans"
    (toggleSelectActionPlan)="openActionPlan($event)"
    [query]="query"
  ></action-plan-list-table>
</div>

<modal (modalOutput)="selectMenu($event)"></modal>
